<template>
  <div class="firm-body">
    <!-- 标题  -->
    <p class="title-Individual-center">
      <span class="firm-clickable" @click="handelReturn">职场信用查询</span>
      <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">{{ routeName }}</span>
    </p>
    <div class="box">
      <div class="box-top flex-box">
        <div class="flex-box2">
          <span style="font-size: 12px">公司历史信用评价：</span>
          <el-select v-model="value" @change="handelSelect" placeholder="请选择" style="width: 300px">
            <el-option v-for="item in CreditEvaluation" :key="item.id"
              :label="item.companyName + '——' + item.createTime.substr(0, 10)" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="flex-box">
          <img style="cursor: pointer" @click="handelDownload(CreditEvaluationObj.applyForEvaluate)"
            src="@/assets/imgs/xiazai@3x.svg" alt="" />
          <span class="firm-clickable" @click="handelDownload(CreditEvaluationObj.applyForEvaluate)"
            style="font-size: 12px; margin-left: 15px; cursor: pointer">下载职场信用评价申请书</span>
          <div class="Back-btn" @click="handelReturn">
            <div class="Back-style">
              <div></div>
              <p>返回</p>
            </div>
          </div>
        </div>
      </div>
      <div class="box-title" style="margin-top: 20px">
        <span>基本信息</span>
        <img src="@/assets/imgs/zhuangshi@3x.svg" alt="" />
      </div>
      <div class="information">
        <el-row :gutter="20">
          <el-col :span="8">
            员工姓名：
            <span class="info-ellipsis" :title="CreditEvaluationObj.name">{{
              CreditEvaluationObj.name
            }}</span>
          </el-col>
          <el-col :span="8">
            身份证号：
            <span class="info-ellipsis" :title="CreditEvaluationObj.idNumber">{{
              CreditEvaluationObj.idNumber
            }}</span>
          </el-col>
          <el-col :span="8">
            <div class="flex-box2">
              <div class="flex-box2" style="margin-right: 30px">
                <img src="@/assets/imgs/dianhua-weijiaohuan@3x.svg" alt="" />
                <span class="info-ellipsis-sm" style="margin-left: 10px" :title="CreditEvaluationObj.phone">{{
                  CreditEvaluationObj.phone }}</span>
              </div>
              <div class="flex-box2">
                <img src="@/assets/imgs/youxiang@3x.svg" alt="" />
                <span class="info-ellipsis-sm" style="margin-left: 10px" :title="CreditEvaluationObj.mail">{{
                  CreditEvaluationObj.mail }}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            性别：{{ CreditEvaluationObj.sex == 0 ? "女" : "男" }}
          </el-col>
          <el-col :span="8">
            身份证地址：
            <span class="info-ellipsis" :title="CreditEvaluationObj.idAddress">{{ CreditEvaluationObj.idAddress
              }}</span>
          </el-col>
          <el-col :span="8">
            <span style="margin-right: 12px">
              所在部门：
              <span class="info-ellipsis-xs" :title="CreditEvaluationObj.deptName">{{ CreditEvaluationObj.deptName
                }}</span>
            </span>
            <span>
              所在职位：
              <span class="info-ellipsis-xs" :title="CreditEvaluationObj.positionName">{{
                CreditEvaluationObj.positionName }}</span>
            </span>
          </el-col>
          <el-col :span="8">
            出生日期：
            <span class="info-ellipsis" :title="CreditEvaluationObj.birthday">{{
              CreditEvaluationObj.birthday ? CreditEvaluationObj.birthday.substring(0,10) : '--'
            }}</span>
          </el-col>
          <el-col :span="8">
            现居地址：
            <span class="info-ellipsis" :title="CreditEvaluationObj.currentAddress">{{
              CreditEvaluationObj.currentAddress }}</span>
          </el-col>
          <el-col :span="8">
            在职时间：
            <span class="info-ellipsis" :title="`${CreditEvaluationObj.jobStartTime || ''} - ${CreditEvaluationObj.leaveTime || ''
              }`">
              {{ CreditEvaluationObj.jobStartTime }} -
              {{ CreditEvaluationObj.leaveTime }}
            </span>
          </el-col>
        </el-row>
      </div>
      <div style="display: flex;align-items: center;width: 100%;">
        <div class="box-title">
          <span>打分表</span>
          <img src="@/assets/imgs/zhuangshi@3x.svg" alt="">
        </div>
        <div style="font-size: 14px;color: #999999;margin-left: 20px;">
          （评价人：{{ CreditEvaluationObj.createByName }}）
        </div>
      </div>
      <div>

        <el-table :data="tableData" border stripe style="width: 100%; font-size: 12px"
          :cell-style="{ textAlign: 'center' }" :header-cell-style="{
            background: '#409eff ',
            textAlign: 'center',
            color: '#ffffff',
            padding: '3px',
            fontSize: '12px',
            fontWeight: '400',
            height: '45px',
            border: 0,
          }" :span-method="arraySpanMethod">
          <el-table-column prop="date" label="评内容" width="120">
          </el-table-column>
          <el-table-column prop="name" label="评价指标" width="120">
          </el-table-column>
          <el-table-column prop="address" label="指标描述" style="text-align: left">
          </el-table-column>
          <el-table-column prop="sum" label="总分值" width="80">
          </el-table-column>
          <el-table-column prop="address" label="评分" width="320">
            <template slot-scope="scope">
              <div class="pf-box" v-if="scope.row.sum == 10">
                <div :class="scope.row.pingfen == 10 ? 'pf-item active' : 'pf-item'
                  ">
                  优（10）
                </div>
                <div :class="scope.row.pingfen == 8 ? 'pf-item active' : 'pf-item'">
                  良（8）
                </div>
                <div :class="scope.row.pingfen == 6 ? 'pf-item active' : 'pf-item'">
                  一般（6）
                </div>
                <div :class="scope.row.pingfen == 3 ? 'pf-item active' : 'pf-item'">
                  差（3）
                </div>
              </div>
              <div class="pf-box" v-if="scope.row.sum == 20">
                <div :class="scope.row.pingfen == 20 ? 'pf-item active' : 'pf-item'
                  ">
                  优（20）
                </div>
                <div :class="scope.row.pingfen == 16 ? 'pf-item active' : 'pf-item'
                  ">
                  良（16）
                </div>
                <div :class="scope.row.pingfen == 12 ? 'pf-item active' : 'pf-item'
                  ">
                  一般（12）
                </div>
                <div :class="scope.row.pingfen == 6 ? 'pf-item active' : 'pf-item'">
                  差（6）
                </div>
              </div>
              <span v-if="scope.row.isShow">
                {{ scope.row.pingfen }}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <div style="
            font-size: 12px;
            color: #666;
            text-align: center;
            height: 60px;
            background: #eeeeee;
            border: 1px solid #eeeeee;
          ">
          <p style="line-height: 35px">
            优秀：完全胜任岗位要求(95-100分);
            <span style="margin-left: 20px">良好：很好地达到岗位任职要求(80-95分);</span>
          </p>
          <p>
            一般：勉强达到岗位任职要求(60-80分);
            <span style="margin-left: 20px">较差：明显不符合岗位任职要求(60 分以下)。</span>
          </p>
        </div>
      </div>
      <div class="box-title">
        <span>辅助材料</span>
        <img src="@/assets/imgs/zhuangshi@3x.svg" alt="" />
      </div>
      <div class="Materials" v-if="
        CreditEvaluationObj.contractList?.length > 0 ||
        CreditEvaluationObj.resumeList?.length > 0 ||
        CreditEvaluationObj.assistantList?.length > 0
      ">
        <div class="MaterialsDisplay" v-if="CreditEvaluationObj.contractList?.length > 0"
          @click="handelDownload(CreditEvaluationObj.contractList)">
          <img src="../../../../assets/imgs/wenjian@3x.svg" alt="" />
          <p :style="CreditEvaluationObj.contractList != null &&
              CreditEvaluationObj.contractList != []
              ? ''
              : 'color:#CFCFCF'
            ">
            劳动合同
          </p>
        </div>
        <div v-if="CreditEvaluationObj.resumeList?.length > 0" class="MaterialsDisplay"
          @click="handelDownload(CreditEvaluationObj.resumeList)">
          <img src="../../../../assets/imgs/wenjian@3x.svg" alt="" />
          <p :style="CreditEvaluationObj.resumeList != null &&
              CreditEvaluationObj.resumeList != []
              ? ''
              : 'color:#CFCFCF'
            ">
            简历
          </p>
        </div>
        <div class="MaterialsDisplay" v-for="(item, index) in CreditEvaluationObj.assistantList" :key="index"
          @click="handelViewTheMaterials(item)">
          <img src="../../../../assets/imgs/wenjian@3x.svg" alt="" />
          <p>{{ item.attaName }}</p>
        </div>
      </div>
      <div v-else class="Materials" style="font-size: 14px">--</div>
      <div class="box-title">
        <span>意向</span>
        <img src="@/assets/imgs/zhuangshi@3x.svg" alt="" />
      </div>
      <div>
        <p style="font-size: 14px; color: #333333">
          <span>意向城市：</span>{{ CreditEvaluationObj.intentionCity || "--" }}
          <span style="margin-left: 40px">意向职位：</span>{{ CreditEvaluationObj.intentionPosition || "--"
          }}<span style="margin-left: 40px">意向行业：</span>{{ CreditEvaluationObj.intentionIndustry || "--" }}
        </p>
      </div>
      <div class="box-title">
        <span>备注信息</span>
        <img src="@/assets/imgs/zhuangshi@3x.svg" alt="" />
      </div>
      <div>
        <!-- <p style="font-size: 14px; color: #999999">
          {{ CreditEvaluationObj.createTime }}
        </p> -->
        <p style="font-size: 14px; color: #333333">
          {{ CreditEvaluationObj.remark || "--" }}
        </p>
      </div>
      <div class="AddRegion">
        <p>追加内容</p>
      </div>
      <div class="box-title">
        <span>追加材料</span>
        <img src="@/assets/imgs/zhuangshi@3x.svg" alt="" />
      </div>
      <div class="Materials" v-if="CreditEvaluationObj.appendList?CreditEvaluationObj.appendList.length > 0:false">
        <div class="MaterialsDisplay" v-for="(item1, index1) in CreditEvaluationObj.appendList" :key="index1 + 10"
          @click="handelViewTheMaterials(item1)">
          <img src="../../../../assets/imgs/wenjian@3x.svg" alt="" />
          <p>{{ item1.attaName }}</p>
        </div>
      </div>
      <div v-else class="Materials" style="font-size: 14px">--</div>
      <div class="box-title">
        <span>追加备注</span>
        <img src="@/assets/imgs/zhuangshi@3x.svg" alt="" />
      </div>
      <div>
        <!-- <p style="font-size: 14px; color: #999999">
          {{ CreditEvaluationObj.updateTime }}
        </p> -->
        <p style="font-size: 14px; color: #333333">
          {{ CreditEvaluationObj.appendRemark || "--" }}
        </p>
      </div>
    </div>

    <Purchase :dialogPurchase="dialogPurchase" @handleClosePurchase="handleClosePurchase"></Purchase>
  </div>
</template>

<script>
import { postGetStsDowLoadPath } from "../../../../assets/api/index";
import Purchase from "./components/Purchase.vue"; //购买
import {
  lookUserCreditEvaluationByCreditId, //公司管理员在信用库查看信用评价
} from "../../../../assets/api/firm/HumanResources";
export default {
  data() {
    return {
      routeName: "",
      value: 11,
      radio4: "上海",
      tableData: [
        {
          date: "基础能力",
          name: "服务知识",
          address:
            "是否充分具备现任职务所要求的基础知识和专业技能知识，是否具备丰富的本职工作经验，是否能够不断更新自己的专业知识",
          sum: 10,
          pingfen: 0,
        },
        {
          date: "基础能力",
          name: "学习创新",
          address:
            "是否掌握系统的理论知识，能够将工作中的经验进行总结提炼并有所创新，并能够将所学传授他人",
          sum: 10,
          pingfen: 0,
        },
        {
          date: "基础能力",
          name: "执行能力",
          address:
            "是否自觉遵守各项规章制度，是否依照既定的计划、原则和办法执行工作任务，关注细节，有意识地在工作中寻求规律技巧，提升工作效率与水平",
          sum: 10,
          pingfen: 0,
        },
        {
          date: "基础能力",
          name: "协同能力",
          address:
            "是否具有全局意识，能否主动为他人提供帮助，主动配合其他部门或岗位进行相关工作，善于与人沟通，能有效地化解工作中的矛盾",
          sum: 10,
          pingfen: 0,
        },
        {
          date: "工作任务",
          name: "工作效率",
          address:
            "能否在规定时间内较好地完成工作，是否除自觉完成本职工作外，还能承担分外的工作",
          sum: 20,
          pingfen: 0,
        },
        {
          date: "工作任务",
          name: "工作成果",
          address: "能否按照事先拟定计划或目标保质保量地完成工作任务",
          sum: 20,
          pingfen: 0,
        },
        {
          date: "工作态度",
          name: "积极性和责任感",
          address:
            "工作是否积极主动;是否具有较高的责任感;是否严格遵守工作纪律和规章制度。",
          sum: 20,
          pingfen: 0,
        },
        {
          date: "合计",
          name: "合计",
          address: "合计1",
          sum: 0,
          pingfen: 0,
          isShow: true,
        },
      ],
      CreditEvaluation: [], //所有信用评价
      CreditEvaluationObj: {}, // 选中展示的信用评价
      dialogPurchase: false, // 购买弹窗
    };
  },
  components: { Purchase },
  created() {
    this.routeName = this.$route.name;
    this.handelTotal();
    this.lookUserCreditEvaluationByCreditId();
  },
  methods: {
    // 购买弹窗取消购买
    handleClosePurchase() {
      this.$router.push({
        path: "/Firm/creditQuery",
        // query: {
        //   key: item.creditId,
        // },
      });
    },
    // 点击文件 下载文件
    handelDownload(val) {
      for (var k in val) {
        postGetStsDowLoadPath(val[k].docId).then((res) => {
          if (res.code == 0) {
            let a = document.createElement("a");
            a.href = res.data;
            a.click();
          }
        });
      }
    },
    // 下载
    handelViewTheMaterials(item) {
      postGetStsDowLoadPath(item.docId).then((res) => {
        if (res.code == 0) {
          let a = document.createElement("a");
          a.href = res.data;
          a.click();
        }
      });
    },
    // 在上方筛选中选择某项
    handelSelect() {
      for (var i in this.CreditEvaluation) {
        if (this.CreditEvaluation[i].id == this.value) {
          this.CreditEvaluationObj = this.CreditEvaluation[i];
          this.tableData[0].pingfen =
            this.CreditEvaluationObj.score.professionalKnowledge; //服务知识
          this.tableData[1].pingfen =
            this.CreditEvaluationObj.score.learningInnovation; //学习创新
          this.tableData[2].pingfen =
            this.CreditEvaluationObj.score.executionAbility; //执行能力
          this.tableData[3].pingfen = this.CreditEvaluationObj.score.synergy; // 协同
          this.tableData[4].pingfen =
            this.CreditEvaluationObj.score.workingEfficiency; // 效率
          this.tableData[5].pingfen =
            this.CreditEvaluationObj.score.workAchievements; // 成果
          this.tableData[6].pingfen = this.CreditEvaluationObj.score.enthusiasm; // 积极性
          this.handelTotal();
        }
      }
    },
    // 合计
    handelTotal() {
      let sum = 0;
      this.tableData[this.tableData.length - 1].pingfen = 0;
      for (var i in this.tableData) {
        sum += this.tableData[i].pingfen * 1;
      }
      this.tableData[this.tableData.length - 1].pingfen = sum;
    },
    // ------------------ 数据列表接口
    async lookUserCreditEvaluationByCreditId() {
      var data = {
        data: {
          creditId: this.$route.query.key,
        },
      };
      // 调用 接口
      const res = await lookUserCreditEvaluationByCreditId(data);
      if (res.code == 2016) {
        this.dialogPurchase = true;
      } else {
        this.tableData[0].pingfen = res.data[0].score.professionalKnowledge; //服务知识
        this.tableData[1].pingfen = res.data[0].score.learningInnovation; //学习创新
        this.tableData[2].pingfen = res.data[0].score.executionAbility; //执行能力
        this.tableData[3].pingfen = res.data[0].score.synergy; // 协同
        this.tableData[4].pingfen = res.data[0].score.workingEfficiency; // 效率
        this.tableData[5].pingfen = res.data[0].score.workAchievements; // 成果
        this.tableData[6].pingfen = res.data[0].score.enthusiasm; // 积极性
        this.value = res.data[0].id;
        this.CreditEvaluationObj = res.data[0];
        this.CreditEvaluation = res.data;
        this.handelTotal();
      }
    },
    // 返回
    handelReturn() {
      this.$router.push({
        path: "/Firm/creditQuery",
      });
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      // 针对第一列（columnIndex === 0）
      if (columnIndex === 0) {
        // 前四行合并（rowIndex 0-3）
        if (rowIndex < 4) {
          // 第一行返回合并 4 行
          if (rowIndex === 0) {
            return { rowspan: 4, colspan: 1 };
          } else {
            // 后续行隐藏
            return { rowspan: 0, colspan: 0 };
          }
        } else if (rowIndex < 6) {
          // 第五行单独显示
          if (rowIndex === 4) {
            return { rowspan: 2, colspan: 1 };
          } else {
            // 后续行隐藏
            return { rowspan: 0, colspan: 0 };
          }
        }
      }
      if (rowIndex === 7) {
        if (columnIndex < 3) {
          // 第一行返回合并 4 行
          if (columnIndex === 0) {
            return { rowspan: 1, colspan: 3 };
          } else {
            // 后续行隐藏
            return { rowspan: 0, colspan: 0 };
          }
        } else {
          return { rowspan: 1, colspan: 1 };
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
// 追加
.AddRegion {
  width: 100%;
  height: 40px;
  display: flex;
  margin-top: 50px;

  p {
    width: 300px;
    height: 40px;
    background: #409eff ;
    border-radius: 10px;
    font-size: 16px;
    color: #ffffff;
    text-align: center;
    line-height: 40px;
    margin: auto;
  }
}

.Back-btn {
  width: 110px;
  height: 30px;
  background: rgba(97, 144, 232, 0.3);
  border-radius: 5px;
  display: flex;
  cursor: pointer;
  margin-left: 30px;

  .Back-style {
    width: 50px;
    height: 17px;
    line-height: 17px;
    margin: auto;
    display: flex;

    div {
      width: 14px;
      height: 17px;
      background-image: url("../../../../assets/imgs/back-da@3x.svg");
      background-size: 100% 100%;
    }

    p {
      font-size: 14px;
      color: #409eff ;
      margin-left: 5px;
      cursor: pointer;
    }
  }
}

.firm-body {
  .box {
    width: 100%;
    min-height: 700px;
    box-sizing: border-box;
    margin-top: 20px;
    padding: 30px;
    background: #ffffff;
    box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
    border-radius: 15px;

    .box-title {
      width: 80px;
      height: 60px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      span {
        font-size: 20px;
        font-weight: 500;
        color: #333;
        font-family: PingFangSC-Medium;
      }

      img {
        position: absolute;
        bottom: 15px;
        left: 0px;
      }
    }

    .information {
      height: 130px;
      background: #ffffff;
      border: 1px solid #eeeeee;
      border-radius: 5px;
      padding: 20px 30px;
      font-size: 12px;
      box-sizing: border-box;
    }

    .pf-box {
      display: flex;
      align-items: center;
      width: 300px;
      box-sizing: border-box;
      border: 1px solid #409eff ;
      border-radius: 15px;
      overflow: hidden;
      margin: 0 auto;

      .pf-item {
        width: 25%;
        border-right: 1px solid #409eff ;
        text-align: center;
        cursor: pointer;
      }

      .pf-item:last-child {
        border-right: 0;
      }

      .active {
        background-color: #409eff ;
        color: #fff;
      }
    }
  }
}

//返回
.Back {
  width: 110px;
  height: 30px;
  background: rgba(97, 144, 232, 0.3);
  border-radius: 5px;
  display: flex;
  position: absolute;
  right: 0;
  top: 5px;
  cursor: pointer;

  .Back-style {
    width: 50px;
    height: 17px;
    line-height: 17px;
    margin: auto;
    display: flex;

    div {
      width: 14px;
      height: 17px;
      background-image: url("../../../../assets/imgs/back-da@3x.svg");
      background-size: 100% 100%;
    }

    p {
      font-size: 14px;
      color: #409eff ;
      margin-left: 5px;
      cursor: pointer;
    }
  }
}

// 上传
.Materials {
  width: 100%;
  // min-height: 100px;
  display: flex;
  flex-wrap: wrap;

  .Upload-box {
    border: 1px dashed #409eff ;
    width: 80px;
    height: 80px;
    background: #ffffff;
    border-radius: 5px;
    display: flex;
    margin-bottom: 10px;

    #file {
      display: none;
    }

    #file1 {
      display: none;
    }

    input {
      border: none;
      box-shadow: none;
      outline: none;
      background-color: transparent;
      width: 100%;
      text-align: center;
      color: #409eff ;
      margin: auto;
    }
  }

  .MaterialsDisplay {
    width: 80px;
    height: 80px;
    margin-left: 10px;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    cursor: pointer;

    img {
      width: 40px;
      height: 50px;
      margin: auto;
    }

    p {
      width: 100%;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 14px;
      color: #333333;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .deleIcon {
      width: 15px;
      height: 15px;
      background-image: url("../../../../assets/imgs/shanchu@3x.svg");
      background-size: 100% 100%;
      position: absolute;
      right: 5px;
      top: 5px;
    }
  }
}

.el-col {
  margin-bottom: 18px;
}

.info-ellipsis {
  display: inline-block;
  max-width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
}

.info-ellipsis-sm {
  display: inline-block;
  max-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
}

.info-ellipsis-xs {
  display: inline-block;
  max-width: 95px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
}
</style>
